import Horizontal from "./Horizontal.template";

export default Horizontal;
